import { BoltIcon, BriefcaseIcon, ClockIcon } from "@heroicons/react/24/solid";

export const listReasonsFinOps = [
  {
    icon : () => {return (<BriefcaseIcon className="w-full"/>)},
    slug : "finops_reason_slug_1",
    title: "finops_reason_title_1",
    description: "finops_reason_description_1"
  },
  {
    icon : () => {return (<BoltIcon className="w-full"/>)},
    slug : "finops_reason_slug_2",
    title: "finops_reason_title_2",
    description: "finops_reason_description_2"
  },
  {
    icon : () => {return (<ClockIcon className="w-full"/>)},
    slug : "finops_reason_slug_3",
    title: "finops_reason_title_3",
    description: "finops_reason_description_3"
  }
]